

module.exports = (rgb) => {
  let r = rgb.red / 255,
      g = rgb.green / 255,
      b = rgb.blue / 255;
  let min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      diff = max - min;
  let lum = (min + max) / 2;
  let sat = min === max ? 0 : lum < 0.5 ? diff / (max + min) : diff / (2 - max - min);
  let hue = max === r ? (g - b) / diff : max === g ? 2 + (b - r) / diff : 4 + (r - g) / diff;
  hue = hue < 0 ? 60 * hue + 360 : 60 * hue;
  return {
    'lum': lum,
    'sat': sat,
    'hue': hue
  };
};



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/rgb/toHsl.js